import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    // Auth
    login: 'Iniciar Sesión',
    register: 'Registrarse',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    name: 'Nombre',
    phone: 'Teléfono',
    cedula: 'Cédula/ID',
    selectUserType: 'Seleccionar Tipo de Usuario',
    admin: 'Administrador',
    distributor: 'Distribuidor',
    client: 'Cliente',
    welcome: 'Bienvenido a',
    loginSubtitle: 'Tu plataforma integral de nutrición y fitness',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    forgotPassword: '¿Olvidaste tu contraseña?',
    
    // Navigation
    dashboard: 'Panel Principal',
    distributors: 'Distribuidores',
    clients: 'Clientes',
    supplements: 'Suplementos',
    orders: 'Pedidos',
    supportClients: 'Soporte Clientes',
    supportDistributors: 'Soporte Distribuidores',
    notifications: 'Notificaciones',
    profile: 'Perfil',
    logout: 'Cerrar Sesión',
    settings: 'Configuración',
    
    // Dashboard
    totalAdmins: 'Administradores',
    totalDistributors: 'Distribuidores',
    totalClients: 'Clientes',
    totalSupplements: 'Suplementos',
    totalOrders: 'Pedidos',
    totalRevenue: 'Ingresos Totales',
    pendingSupportClients: 'Soporte Clientes Pendiente',
    pendingSupportDistributors: 'Soporte Distribuidores Pendiente',
    recentNotifications: 'Notificaciones Recientes',
    overview: 'Resumen General',
    
    // Actions
    create: 'Crear',
    edit: 'Editar',
    delete: 'Eliminar',
    save: 'Guardar',
    cancel: 'Cancelar',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    import: 'Importar',
    viewAll: 'Ver Todos',
    viewProfile: 'Ver Perfil',
    addNew: 'Agregar Nuevo',
    
    // Distributors
    newDistributor: 'Nuevo Distribuidor',
    distributorsList: 'Lista de Distribuidores',
    distributorProfile: 'Perfil del Distribuidor',
    noDistributors: 'No hay distribuidores registrados',
    
    // Clients
    newClient: 'Nuevo Cliente',
    clientsList: 'Lista de Clientes',
    clientProfile: 'Perfil del Cliente',
    noClients: 'No hay clientes registrados',
    
    // Supplements
    newSupplement: 'Nuevo Suplemento',
    supplementsList: 'Lista de Suplementos',
    description: 'Descripción',
    price: 'Precio',
    stock: 'Inventario',
    category: 'Categoría',
    noSupplements: 'No hay suplementos registrados',
    lowStock: 'Stock Bajo',
    outOfStock: 'Agotado',
    inStock: 'En Stock',
    
    // Orders
    newOrder: 'Nuevo Pedido',
    ordersList: 'Lista de Pedidos',
    orderDetails: 'Detalles del Pedido',
    orderStatus: 'Estado del Pedido',
    pending: 'Pendiente',
    processing: 'Procesando',
    shipped: 'Enviado',
    delivered: 'Entregado',
    cancelled: 'Cancelado',
    total: 'Total',
    items: 'Artículos',
    quantity: 'Cantidad',
    unitPrice: 'Precio Unitario',
    noOrders: 'No hay pedidos registrados',
    
    // Support
    newTicket: 'Nuevo Ticket',
    ticketsList: 'Lista de Tickets',
    subject: 'Asunto',
    message: 'Mensaje',
    response: 'Respuesta',
    status: 'Estado',
    open: 'Abierto',
    inProgress: 'En Progreso',
    resolved: 'Resuelto',
    closed: 'Cerrado',
    noTickets: 'No hay tickets de soporte',
    
    // Notifications
    newNotification: 'Nueva Notificación',
    title: 'Título',
    targetAudience: 'Audiencia Objetivo',
    all: 'Todos',
    admins: 'Administradores',
    markAsRead: 'Marcar como Leído',
    noNotifications: 'No hay notificaciones',
    
    // Messages
    success: 'Éxito',
    error: 'Error',
    loading: 'Cargando...',
    confirmDelete: '¿Estás seguro de eliminar?',
    deleteWarning: 'Esta acción no se puede deshacer',
    savedSuccessfully: 'Guardado exitosamente',
    deletedSuccessfully: 'Eliminado exitosamente',
    errorOccurred: 'Ocurrió un error',
    invalidCredentials: 'Credenciales inválidas',
    
    // Time
    createdAt: 'Creado',
    updatedAt: 'Actualizado',
    today: 'Hoy',
    yesterday: 'Ayer',
    thisWeek: 'Esta Semana',
    thisMonth: 'Este Mes',
    
    // Stats
    myClients: 'Mis Clientes',
    myOrders: 'Mis Pedidos',
    myRevenue: 'Mis Ingresos',
    totalSpent: 'Total Gastado',
    
    // Language
    language: 'Idioma',
    spanish: 'Español',
    english: 'Inglés',
  },
  en: {
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    name: 'Name',
    phone: 'Phone',
    cedula: 'ID Number',
    selectUserType: 'Select User Type',
    admin: 'Administrator',
    distributor: 'Distributor',
    client: 'Client',
    welcome: 'Welcome to',
    loginSubtitle: 'Your comprehensive nutrition and fitness platform',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    forgotPassword: 'Forgot your password?',
    
    // Navigation
    dashboard: 'Dashboard',
    distributors: 'Distributors',
    clients: 'Clients',
    supplements: 'Supplements',
    orders: 'Orders',
    supportClients: 'Client Support',
    supportDistributors: 'Distributor Support',
    notifications: 'Notifications',
    profile: 'Profile',
    logout: 'Logout',
    settings: 'Settings',
    
    // Dashboard
    totalAdmins: 'Administrators',
    totalDistributors: 'Distributors',
    totalClients: 'Clients',
    totalSupplements: 'Supplements',
    totalOrders: 'Orders',
    totalRevenue: 'Total Revenue',
    pendingSupportClients: 'Pending Client Support',
    pendingSupportDistributors: 'Pending Distributor Support',
    recentNotifications: 'Recent Notifications',
    overview: 'Overview',
    
    // Actions
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    viewAll: 'View All',
    viewProfile: 'View Profile',
    addNew: 'Add New',
    
    // Distributors
    newDistributor: 'New Distributor',
    distributorsList: 'Distributors List',
    distributorProfile: 'Distributor Profile',
    noDistributors: 'No distributors registered',
    
    // Clients
    newClient: 'New Client',
    clientsList: 'Clients List',
    clientProfile: 'Client Profile',
    noClients: 'No clients registered',
    
    // Supplements
    newSupplement: 'New Supplement',
    supplementsList: 'Supplements List',
    description: 'Description',
    price: 'Price',
    stock: 'Stock',
    category: 'Category',
    noSupplements: 'No supplements registered',
    lowStock: 'Low Stock',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
    
    // Orders
    newOrder: 'New Order',
    ordersList: 'Orders List',
    orderDetails: 'Order Details',
    orderStatus: 'Order Status',
    pending: 'Pending',
    processing: 'Processing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    total: 'Total',
    items: 'Items',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    noOrders: 'No orders registered',
    
    // Support
    newTicket: 'New Ticket',
    ticketsList: 'Tickets List',
    subject: 'Subject',
    message: 'Message',
    response: 'Response',
    status: 'Status',
    open: 'Open',
    inProgress: 'In Progress',
    resolved: 'Resolved',
    closed: 'Closed',
    noTickets: 'No support tickets',
    
    // Notifications
    newNotification: 'New Notification',
    title: 'Title',
    targetAudience: 'Target Audience',
    all: 'All',
    admins: 'Administrators',
    markAsRead: 'Mark as Read',
    noNotifications: 'No notifications',
    
    // Messages
    success: 'Success',
    error: 'Error',
    loading: 'Loading...',
    confirmDelete: 'Are you sure you want to delete?',
    deleteWarning: 'This action cannot be undone',
    savedSuccessfully: 'Saved successfully',
    deletedSuccessfully: 'Deleted successfully',
    errorOccurred: 'An error occurred',
    invalidCredentials: 'Invalid credentials',
    
    // Time
    createdAt: 'Created',
    updatedAt: 'Updated',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    
    // Stats
    myClients: 'My Clients',
    myOrders: 'My Orders',
    myRevenue: 'My Revenue',
    totalSpent: 'Total Spent',
    
    // Language
    language: 'Language',
    spanish: 'Spanish',
    english: 'English',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('nutriquimia-language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('nutriquimia-language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
